import JobDetailPage from '@/pages/jobs/detail'
import { WorkspacePortalProvider } from '@/contexts/workspace-portal-context'

export default function EventDetailPage() {
  return (
    <WorkspacePortalProvider mode="event">
      <JobDetailPage />
    </WorkspacePortalProvider>
  )
}
